import React, { useEffect, useState } from "react";

import FoodMenuService from "../../../../Services/QRCodeServices/CustomerService/FoodMenuService";
import { Col, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
// import { MenuItem } from "./MenuItem";
// import { MenuItem } from "../../component/MenuItem";
import { MobileMenuItemDetail } from "./MobileMenuItemDetail";
import { MobileMenuItem } from "./MobileMenuItem";

import { MobileOrgTable } from "./MobileOrgTable";

import { OrderMenu } from "../../component/OrderMenu";

import { Pagination } from "../../component/Pagination";
import TableService from "../../../../Services/QRCodeServices/TableSerivce/TableService";

export const MobileFoodMenu = ({searchTerm,selectedTable,setSelectedTable,setOrderPlaced}) => {
  const [menuData, setMenuData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
  const [userInfo, setUserInfo] = useState(null);
  const [orgCode, setOrgCode] = useState(null);
  const [tables, setTables] = useState([]);
  // const [selectedTable, setSelectedTable] = useState(null);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
      setOrgCode(parsedUserInfo?.organizationInfo?.orgCode || null);
    }
  }, []);

  useEffect(() => {
    const fetchMenuData = async () => {
      if (!orgCode) {
        setError("Organization code is required");
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        const data = await FoodMenuService.getFoodMenu(orgCode);

        if (!data || !data.allMenu) {
          throw new Error("Invalid menu data received");
        }

        // Filter out categories with no menu items
        const filteredMenuData = data.allMenu.filter(
          (category) => category.menuItem && category.menuItem.length > 0
        );

        setMenuData(filteredMenuData);

        // If the currently selected category is now empty, switch to 'all'
        if (
          selectedCategory !== "all" &&
          !filteredMenuData.find((cat) => cat.name === selectedCategory)
        ) {
          setSelectedCategory("all");
        }
      } catch (error) {
        setError(
          error.response?.status === 500
            ? "Server error. Please try again later."
            : "Failed to load menu. Please check your connection and try again."
        );
        console.error("Failed to fetch menu data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMenuData();
  }, [orgCode]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedCategory]);

  const handleOrderUpdate = async () => {
    // Refresh the table data in OrderMenu component
    if (selectedTable) {
      try {
        const response = await TableService.getActiveTableList();
        const updatedTableData = response.find(
          (table) => table.id === selectedTable.id
        );
        // Update the selected table data
        setSelectedTable((prevState) => ({
          ...prevState,
          ...updatedTableData,
        }));
      } catch (error) {
        console.error("Error refreshing table data:", error);
        toast.error("Failed to refresh table data");
      }
    }
  };
  const getAllMenuItems = () => {
    return menuData.reduce((items, category) => {
      return [...items, ...category.menuItem];
    }, []);
  };

  const getFilteredContent = () => {
    let filteredItems = [];

    if (selectedCategory === "all") {
      filteredItems = getAllMenuItems();
    } else {
      const selectedCategoryData = menuData.find(
        (category) => category.name === selectedCategory
      );
      filteredItems = selectedCategoryData ? selectedCategoryData.menuItem : [];
    }

    return filteredItems.filter((item) =>
      item.title?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const getPaginatedContent = () => {
    const filteredContent = getFilteredContent();
    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredContent.slice(startIndex, startIndex + itemsPerPage);
  };

  const totalPages = Math.ceil(getFilteredContent().length / itemsPerPage);

  const handleCategoryClick = (categoryName) => {
    setSelectedCategory(categoryName);
  };

  // Check if there are any menu items at all
  const hasMenuItems = menuData.some(
    (category) => category.menuItem && category.menuItem.length > 0
  );

  if (isLoading) {
    return (
      <div className="text-center h-100 d-flex w-100 justify-content-center align-items-center p-4">
        <Triangle
          visible={true}
          height="80"
          width="80"
          color="#5B71B9"
          ariaLabel="triangle-loading"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  if (!hasMenuItems) {
    return (
      <div className="alert alert-info" role="alert">
        No menu items available at the moment.
      </div>
    );
  }

  console.log(selectedTable)

  return (
    <div className="  pt-3" style={{backgroundColor: "white", height: "100%"}}>

      {/* above option list */}
      <Col xs={12}>
      {menuData.length > 0 && (

<div className=" position-relative container  list-mobilefoodmenu ">
  
  <div
    className="d-flex overflow-auto "
    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
  >
    <div
      className={`flex-shrink-0 me-3 cursor-pointer ${
        selectedCategory === "all"
          ? "border-bottom border-primary border-4"
          : ""
      }`}
      onClick={() => handleCategoryClick("all")}
    >
      <div className="text-center p-2 bg-white rounded-3 shadow-sm">
        <p className="fw-bold mb-0 text-black">All Categories</p>
      </div>
    </div>

    {menuData.map((category, index) => (
      <div
        key={index}
        className={`flex-shrink-0 me-3 cursor-pointer ${
          selectedCategory === category.name
            ? "border-bottom border-primary border-4"
            : ""
        }`}
        onClick={() => handleCategoryClick(category.name)}
      >
        <div className="text-center p-2 bg-white rounded-3 shadow-sm">
          <p className="fw-bold mb-0 text-black">{category.name}</p>
        </div>
      </div>
    ))}
  </div>
</div>


)}
      </Col>

      <Col xs={12} className="pt-4 d-flex " style={{backgroundColor: "white"}}>

      {/* fooditems */}
        <Col xs={9}  className=" pt-1 "> {/*px-3*/}
        
      
        {/* px-3 ps-sm-3 */}
          <Row className="  m-0 overflow-y-scroll  d-flex justify-content-center align-items-center " style={{height: "45vh"}}>

            {getPaginatedContent().map((item, index) => (
              
                <MobileMenuItem
                  key={item.id || index}

                  item={item}
                  selectedTable={selectedTable}
                  onOrderUpdate={handleOrderUpdate}
                  index={index}
                  setOrderPlaced={setOrderPlaced}
                  tables={tables}
                  setSelectedTable={setSelectedTable}
                />
              
            ))}
          </Row>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}

        </Col>

{/* tables */}
        <Col xs={3} className="   m-0 px-1 ">
          {/* <OrderMenu
            selectedTable={selectedTable}
            setSelectedTable={setSelectedTable}
          /> */}
          {/* <Row className=" red m-0 px-1"> */}
          <MobileOrgTable selectedTable={selectedTable} setSelectedTable={setSelectedTable} tables={tables} setTables={setTables}/>
          {/* </Row>     */}

        
        </Col>

      </Col>

    </div>
  );
};
